exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".skeleton-d-locus .skel-d-locus-row-alpha[data-v-1599b1a2]{margin-bottom:.25rem}.skeleton-d-locus .skel-d-locus-row-beta[data-v-1599b1a2]{display:flex;align-items:center;margin-bottom:.275rem}.skeleton-d-locus .skel-d-locus-row-beta .skel-d-locus-row-beta-l[data-v-1599b1a2]{flex:1 1 60%}.skeleton-d-locus .skel-audit[data-v-1599b1a2]{display:flex;align-items:center}.skeleton-d-locus .skel-audit .skel-audit-profile[data-v-1599b1a2]{margin-right:.275rem}", ""]);

// exports
